import { Stack, Tab, Tabs } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

import { useAuth } from '../../auth/useAuth.js';

import { CommissionsReportTab } from './CommissionsReportTab.js';
import { RegulatoryReportsPage } from './RegulatoryReportsPage.js';
import { TransactionsReportTab } from './TransactionsReportTab.js';

/**
 * Reports is a set of tabs (DEV-128/129): Regulatory as before, and the
 * financial reports (Commissions, Transactions). Finance and the client manager see only the financial tabs.
 */
type ReportTab = 'regulatory' | 'commissions' | 'transactions';

export function ReportsPage(): JSX.Element {
  const { can } = useAuth();
  const [params, setParams] = useSearchParams();
  const regulatory = can('reports.regulatory');
  const financial = can('reports.financial');
  const available: ReportTab[] = [
    ...(regulatory ? ['regulatory' as const] : []),
    ...(financial ? ['commissions' as const, 'transactions' as const] : []),
  ];
  const requested = params.get('tab');
  const tab: ReportTab = available.find((t) => t === requested) ?? available[0] ?? 'regulatory';
  const select = (value: ReportTab): void => { setParams(new URLSearchParams(value === available[0] ? {} : { tab: value })); };
  return <Stack spacing={2} sx={{ minWidth: 0 }}>
    {available.length > 1 && <Tabs value={tab} onChange={(_, value: ReportTab) => select(value)} variant="scrollable"
      allowScrollButtonsMobile aria-label="Report types">
      {regulatory && <Tab value="regulatory" label="Regulatory" />}
      {financial && <Tab value="commissions" label="Commissions" />}
      {financial && <Tab value="transactions" label="Transactions" />}
    </Tabs>}
    {tab === 'transactions' ? <TransactionsReportTab /> : tab === 'commissions' ? <CommissionsReportTab /> : <RegulatoryReportsPage />}
  </Stack>;
}
